export default __webpack_public_path__ + "static/media/Gold.641f7b5e.svg";